var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoVmFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410.458,
    height: 258.108,
    viewBox: "0 0 410.458 258.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116575",
    "data-name": "Group 116575",
    transform: "translate(5659.229 -14452.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116573",
    "data-name": "Group 116573",
    transform: "translate(-5662.656 14409.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116128",
    "data-name": "Group 116128",
    transform: "translate(3.427 68.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116111",
    "data-name": "Group 116111",
    transform: "translate(360.877 131.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116109",
    "data-name": "Group 116109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116108",
    "data-name": "Group 116108",
    transform: "translate(6.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114808",
    "data-name": "Path 114808",
    d: "M380.755,343.662c5.236,1.177,14.985-3.894,16.442-11.038,1.359-6.661.159-14.021,6.224-19.007s14.16-22.392,12.288-25.286c-2.707-4.186-15.966.278-21.279,6.544s-3.365,10.439-7.109,15.164-8.966,10.227-11.213,17.488S380.755,343.662,380.755,343.662Z",
    transform: "translate(-375.658 -286.698)",
    fill: "#5fd284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114809",
    "data-name": "Path 114809",
    d: "M384.8,367.642a13.944,13.944,0,0,1,3.973-6.507,19.429,19.429,0,0,1,4.614-2.668,12.607,12.607,0,0,0,7.12-6.455,11.6,11.6,0,0,1,.877-1.372c-.2,1.962-.381,3.94-.773,5.859C399.21,363.366,390.15,368.314,384.8,367.642Z",
    transform: "translate(-379.071 -310.573)",
    fill: "#38c092"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_114810",
    "data-name": "Path 114810",
    d: "M365.446,393.654l.023.006a.52.52,0,0,0,.613-.407c.076-.378,7.87-38.221,27.65-75.5a.52.52,0,0,0-.919-.487c-19.854,37.417-27.674,75.4-27.751,75.78A.52.52,0,0,0,365.446,393.654Z",
    transform: "translate(-365.053 -298.009)",
    fill: "#38c092"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116110",
    "data-name": "Group 116110",
    transform: "translate(3.027 32.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114811",
    "data-name": "Path 114811",
    d: "M388,376.266c-3.454-3.933-1.412-14.989,2.627-18.292s8.262-2.35,12.247-9.746c3.668-6.805,17.771-11.285,18.911-10.2,2.19,2.075-.5,14.167-6.3,18.4-9.441,6.88-8.175,14.06-13.083,18.266C395.987,380.186,388,376.266,388,376.266Z",
    transform: "translate(-375.993 -337.864)",
    fill: "#5fd284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114812",
    "data-name": "Path 114812",
    d: "M370.277,412.953a.52.52,0,0,0,.63-.378c5.588-22.414,25.965-44.824,26.171-45.048a.52.52,0,1,0-.766-.7c-.207.226-20.76,22.826-26.413,45.5A.52.52,0,0,0,370.277,412.953Z",
    transform: "translate(-369.883 -348.614)",
    fill: "#38c092"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116563",
    "data-name": "Group 116563",
    transform: "translate(0 131.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116109-2",
    "data-name": "Group 116109",
    transform: "translate(2.609 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116108-2",
    "data-name": "Group 116108",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114808-2",
    "data-name": "Path 114808",
    d: "M410.886,343.662c-5.236,1.177-14.985-3.894-16.442-11.038-1.359-6.661-.159-14.021-6.224-19.007s-14.16-22.392-12.288-25.286c2.707-4.186,15.966.278,21.279,6.544s3.365,10.439,7.109,15.164,8.966,10.227,11.213,17.488S410.886,343.662,410.886,343.662Z",
    transform: "translate(-375.658 -286.698)",
    fill: "#5fd284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114809-2",
    "data-name": "Path 114809",
    d: "M401.383,367.642a13.946,13.946,0,0,0-3.973-6.507,19.431,19.431,0,0,0-4.614-2.668,12.607,12.607,0,0,1-7.12-6.455,11.6,11.6,0,0,0-.877-1.372c.2,1.962.381,3.94.773,5.859C386.972,363.366,396.032,368.314,401.383,367.642Z",
    transform: "translate(-366.785 -310.573)",
    fill: "#38c092"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_114810-2",
    "data-name": "Path 114810",
    d: "M393.4,393.654l-.023.006a.52.52,0,0,1-.613-.407c-.076-.378-7.87-38.221-27.65-75.5a.52.52,0,0,1,.919-.487c19.854,37.417,27.674,75.4,27.751,75.78A.52.52,0,0,1,393.4,393.654Z",
    transform: "translate(-346.822 -298.009)",
    fill: "#38c092"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116110-2",
    "data-name": "Group 116110",
    transform: "translate(0 32.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114811-2",
    "data-name": "Path 114811",
    d: "M420.789,376.266c3.454-3.933,1.412-14.989-2.627-18.292s-8.262-2.35-12.247-9.746c-3.668-6.805-17.771-11.285-18.911-10.2-2.19,2.075.5,14.167,6.3,18.4,9.441,6.88,8.175,14.06,13.083,18.266C412.8,380.186,420.789,376.266,420.789,376.266Z",
    transform: "translate(-386.246 -337.864)",
    fill: "#5fd284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114812-2",
    "data-name": "Path 114812",
    d: "M396.821,412.953a.52.52,0,0,1-.63-.378c-5.588-22.414-25.965-44.824-26.171-45.048a.52.52,0,1,1,.766-.7c.207.226,20.76,22.826,26.413,45.5A.52.52,0,0,1,396.821,412.953Z",
    transform: "translate(-350.661 -348.614)",
    fill: "#38c092"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116107",
    "data-name": "Group 116107",
    transform: "translate(29.654 7.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116100",
    "data-name": "Group 116100",
    transform: "translate(9.648 94.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116098",
    "data-name": "Group 116098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114797",
    "data-name": "Path 114797",
    d: "M206.047,175.4v48.539H160.256V164.406h34.8Z",
    transform: "translate(-160.256 -164.406)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114798",
    "data-name": "Path 114798",
    d: "M226.784,175.4h-8.243a2.747,2.747,0,0,1-2.748-2.747v-8.242Z",
    transform: "translate(-180.993 -164.406)",
    fill: "#cfd7fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116099",
    "data-name": "Group 116099",
    transform: "translate(17.36 18.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114799",
    "data-name": "Path 114799",
    d: "M193.1,210.668a1.142,1.142,0,0,1-1.1-1.181l.2-5.618a1.142,1.142,0,0,1,1.181-1.1,3.253,3.253,0,1,0-3.138-3.365,1.142,1.142,0,0,1-2.282-.08,5.537,5.537,0,1,1,6.486,5.648l-.16,4.6A1.142,1.142,0,0,1,193.1,210.668Z",
    transform: "translate(-187.96 -193.979)",
    fill: "#cfd7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114800",
    "data-name": "Path 114800",
    d: "M196.961,225.89A1.826,1.826,0,1,1,195.2,224,1.827,1.827,0,0,1,196.961,225.89Z",
    transform: "translate(-189.957 -205.188)",
    fill: "#cfd7fe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116103",
    "data-name": "Group 116103",
    transform: "translate(0 153.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116101",
    "data-name": "Group 116101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114801",
    "data-name": "Path 114801",
    d: "M96.511,134.589l18.575,44.844L72.781,196.957,50,141.96l32.152-13.318Z",
    transform: "translate(-50 -128.642)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114802",
    "data-name": "Path 114802",
    d: "M115.67,134.589l-7.615,3.154a2.746,2.746,0,0,1-3.589-1.487l-3.154-7.615Z",
    transform: "translate(-69.159 -128.642)",
    fill: "#cfd7fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116102",
    "data-name": "Group 116102",
    transform: "translate(20.652 20.164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22414",
    "data-name": "Rectangle 22414",
    width: 6.869,
    height: 22.896,
    transform: "translate(10.683 23.781) rotate(-157.5)",
    fill: "#cfd7fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22415",
    "data-name": "Rectangle 22415",
    width: 6.869,
    height: 22.896,
    transform: "translate(0 10.683) rotate(-67.5)",
    fill: "#cfd7fe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116104",
    "data-name": "Group 116104",
    transform: "translate(65.086 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114803",
    "data-name": "Path 114803",
    d: "M169.31,78.632a1.109,1.109,0,0,1-1.41-.688l-1.778-5.165a1.109,1.109,0,0,1,.687-1.41,3.161,3.161,0,1,0-4.019-1.96,1.109,1.109,0,1,1-2.1.723A5.38,5.38,0,1,1,168.543,73L170,77.222A1.109,1.109,0,0,1,169.31,78.632Z",
    transform: "translate(-160.399 -63)",
    fill: "#66c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114804",
    "data-name": "Path 114804",
    d: "M177.481,92.008a1.775,1.775,0,1,1-2.256-1.1A1.774,1.774,0,0,1,177.481,92.008Z",
    transform: "translate(-165.488 -73.384)",
    fill: "#66c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116105",
    "data-name": "Group 116105",
    transform: "translate(326.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114805",
    "data-name": "Path 114805",
    d: "M247.587,94.911a1.321,1.321,0,0,1-.819-1.679l2.118-6.152a1.321,1.321,0,0,1,1.679-.819,3.765,3.765,0,1,0-2.334-4.786,1.321,1.321,0,1,1-2.5-.86A6.407,6.407,0,1,1,251,89.061l-1.733,5.032A1.321,1.321,0,0,1,247.587,94.911Z",
    transform: "translate(-244.174 -76.293)",
    fill: "#66c5ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 2.114,
    cy: 2.114,
    r: 2.114,
    transform: "translate(0 20.885)",
    fill: "#66c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116106",
    "data-name": "Group 116106",
    transform: "translate(349.983 46.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114806",
    "data-name": "Path 114806",
    d: "M407.556,186.851a8.648,8.648,0,1,1,12.23,0A8.647,8.647,0,0,1,407.556,186.851Zm1.112-1.112a7.076,7.076,0,1,0,0-10.006A7.083,7.083,0,0,0,408.667,185.74Z",
    transform: "translate(-396.73 -172.089)",
    fill: "#66c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114807",
    "data-name": "Path 114807",
    d: "M392.019,204.489l10.562-10.562,1.112,1.112L393.13,205.6a.786.786,0,0,1-1.112,0h0A.786.786,0,0,1,392.019,204.489Z",
    transform: "translate(-391.789 -180.243)",
    fill: "#66c5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116123",
    "data-name": "Group 116123",
    transform: "translate(201.626 115.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114848",
    "data-name": "Path 114848",
    d: "M340.632,270.061h-5.777a1,1,0,0,0-1.006.986v3.2a.841.841,0,0,0,.91.831h.128a.9.9,0,0,0,.9-.831h.013a.9.9,0,0,0,.9.831h.128a.9.9,0,0,0,.9-.831h.013a.9.9,0,0,0,.9.831h.128c.915,0,.872-.725.9-1.189h.013a.9.9,0,0,0,.9.831h.128a.9.9,0,0,0,.9-.831h.006v-2.838A1,1,0,0,0,340.632,270.061Z",
    transform: "translate(-333.849 -270.061)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116122",
    "data-name": "Group 116122",
    transform: "translate(1.716 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114849",
    "data-name": "Path 114849",
    d: "M336.818,270.061a9.434,9.434,0,0,1,.007,4.182,8.292,8.292,0,0,1-.238-2.091A8.407,8.407,0,0,1,336.818,270.061Z",
    transform: "translate(-336.587 -270.061)",
    fill: "#ff847f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114850",
    "data-name": "Path 114850",
    d: "M339.925,270.061a9.423,9.423,0,0,1,0,4.182,8.321,8.321,0,0,1-.235-2.091A8.406,8.406,0,0,1,339.925,270.061Z",
    transform: "translate(-337.746 -270.061)",
    fill: "#ff847f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114851",
    "data-name": "Path 114851",
    d: "M343.042,270.061a7.058,7.058,0,0,1,.235,1.912,6.962,6.962,0,0,1-.235,1.912,6.986,6.986,0,0,1-.234-1.912A7.058,7.058,0,0,1,343.042,270.061Z",
    transform: "translate(-338.91 -270.061)",
    fill: "#ff847f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(270.502 35.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116346",
    "data-name": "Group 116346",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116242",
    "data-name": "Group 116242",
    transform: "translate(36.984 0.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114877",
    "data-name": "Path 114877",
    d: "M150.2,92.351a16.422,16.422,0,0,0-3.711,10.518c.023,2.169.423,4.56-.839,6.324-.957,1.339-2.7,2.009-3.481,3.459-.936,1.744-.138,3.948-.714,5.842-.816,2.685-3.96,3.807-5.825,5.9a7.453,7.453,0,0,0-1.564,6.825,7.685,7.685,0,0,0,4.821,5.1,4.994,4.994,0,0,0,3.816-.064,6.635,6.635,0,0,0,2.672-3.177c1.242-2.476,12.127-15.872,12.743-18.573",
    transform: "translate(-133.807 -89.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114878",
    "data-name": "Path 114878",
    d: "M93.1,86.107c4.451-.717,8.729,2.239,10.6,6.338s1.927,8.762,2.065,13.269.454,9.21,2.755,13.088c1.46,2.461,3.721,4.62,4.075,7.459.318,2.542-1,5.1-.561,7.627.38,2.2,2.055,4.111,1.989,6.34-.08,2.682-2.839,4.7-5.521,4.775s-5.189-1.334-7.292-3a28.043,28.043,0,0,1-8-10.171",
    transform: "translate(-68.789 -85.999)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116289",
    "data-name": "Group 116289",
    transform: "translate(50.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116288",
    "data-name": "Group 116288",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116274",
    "data-name": "Group 116274",
    transform: "translate(0 1.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116273",
    "data-name": "Group 116273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116243",
    "data-name": "Group 116243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114879",
    "data-name": "Path 114879",
    d: "M137.248,97.9a8.427,8.427,0,0,0-7.574-9.438,8.6,8.6,0,0,0-9.159,7.379,87.814,87.814,0,0,0-1.079,9.3c.055,4.324,2.585,6.008,3.611,6.514a5.6,5.6,0,0,0,1.138.283h0a.029.029,0,0,1,.024.034l-.96,4.965c-.435,3.252,1.38,6.154,4.628,6.627s5.805-2.024,6.3-5.279Z",
    transform: "translate(-119.436 -88.424)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116249",
    "data-name": "Group 116249",
    transform: "translate(1.957 8.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116248",
    "data-name": "Group 116248",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116247",
    "data-name": "Group 116247",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116246",
    "data-name": "Group 116246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116245",
    "data-name": "Group 116245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116244",
    "data-name": "Group 116244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114880",
    "data-name": "Path 114880",
    d: "M145.154,106.023c.071.1.643-.205,1.375-.1s1.215.553,1.307.475c.045-.034-.017-.207-.227-.411a1.882,1.882,0,0,0-1.03-.49,1.808,1.808,0,0,0-1.11.188C145.219,105.828,145.119,105.977,145.154,106.023Z",
    transform: "translate(-145.147 -105.482)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116255",
    "data-name": "Group 116255",
    transform: "translate(8.468 10.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116254",
    "data-name": "Group 116254",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116253",
    "data-name": "Group 116253",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116252",
    "data-name": "Group 116252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116251",
    "data-name": "Group 116251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116250",
    "data-name": "Group 116250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114881",
    "data-name": "Path 114881",
    d: "M132.491,109.1c.071.1.643-.205,1.374-.1s1.215.553,1.307.475c.045-.034-.017-.206-.227-.411a1.878,1.878,0,0,0-1.03-.49,1.809,1.809,0,0,0-1.11.188C132.556,108.9,132.456,109.053,132.491,109.1Z",
    transform: "translate(-132.484 -108.558)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116260",
    "data-name": "Group 116260",
    transform: "translate(4.01 8.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116259",
    "data-name": "Group 116259",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116258",
    "data-name": "Group 116258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116257",
    "data-name": "Group 116257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116256",
    "data-name": "Group 116256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114882",
    "data-name": "Path 114882",
    d: "M142.323,111.525a4.931,4.931,0,0,0-1.158-.388c-.184-.046-.356-.11-.369-.242a.962.962,0,0,1,.206-.536l.76-1.343a24.721,24.721,0,0,0,1.784-3.542,24.766,24.766,0,0,0-2.065,3.39c-.258.473-.5.923-.738,1.355a1.092,1.092,0,0,0-.2.719.476.476,0,0,0,.268.318,1.311,1.311,0,0,0,.311.09A4.77,4.77,0,0,0,142.323,111.525Z",
    transform: "translate(-140.528 -105.473)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116264",
    "data-name": "Group 116264",
    transform: "translate(4.52 22.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116263",
    "data-name": "Group 116263",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116262",
    "data-name": "Group 116262",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116261",
    "data-name": "Group 116261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114883",
    "data-name": "Path 114883",
    d: "M132.262,133.244a11.782,11.782,0,0,0,6.638-.966s-1.66,3.574-6.9,2.3Z",
    transform: "translate(-132.003 -132.278)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116268",
    "data-name": "Group 116268",
    transform: "translate(8.841 8.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116267",
    "data-name": "Group 116267",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116266",
    "data-name": "Group 116266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116265",
    "data-name": "Group 116265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114884",
    "data-name": "Path 114884",
    d: "M130.6,105.526c.043.21.788.222,1.632.45.848.212,1.5.565,1.644.4.063-.078-.03-.283-.282-.517a2.94,2.94,0,0,0-2.5-.649C130.767,105.293,130.585,105.426,130.6,105.526Z",
    transform: "translate(-130.602 -105.15)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116272",
    "data-name": "Group 116272",
    transform: "translate(2.554 7.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116271",
    "data-name": "Group 116271",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116270",
    "data-name": "Group 116270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116269",
    "data-name": "Group 116269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114885",
    "data-name": "Path 114885",
    d: "M144.343,102.819c.1.185.634.086,1.242.166.61.059,1.1.275,1.247.118.064-.077.008-.255-.194-.445a1.813,1.813,0,0,0-2.005-.229C144.393,102.569,144.3,102.73,144.343,102.819Z",
    transform: "translate(-144.332 -102.227)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116280",
    "data-name": "Group 116280",
    transform: "translate(8.849 12.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116279",
    "data-name": "Group 116279",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116278",
    "data-name": "Group 116278",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116277",
    "data-name": "Group 116277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116276",
    "data-name": "Group 116276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116275",
    "data-name": "Group 116275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114886",
    "data-name": "Path 114886",
    d: "M135.84,110.82a.609.609,0,0,1-.694.491.582.582,0,0,1-.511-.659.609.609,0,0,1,.693-.492A.582.582,0,0,1,135.84,110.82Z",
    transform: "translate(-134.628 -110.155)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116286",
    "data-name": "Group 116286",
    transform: "translate(2.367 11.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116285",
    "data-name": "Group 116285",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116284",
    "data-name": "Group 116284",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116283",
    "data-name": "Group 116283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116282",
    "data-name": "Group 116282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116281",
    "data-name": "Group 116281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114887",
    "data-name": "Path 114887",
    d: "M148.447,108.092a.609.609,0,0,1-.694.491.583.583,0,0,1-.512-.659.609.609,0,0,1,.693-.492A.583.583,0,0,1,148.447,108.092Z",
    transform: "translate(-147.235 -107.427)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114888",
    "data-name": "Path 114888",
    d: "M143.328,119.979a.913.913,0,0,1,1.067.444.937.937,0,0,1-.13,1.087.825.825,0,0,1-1.068.076,1.021,1.021,0,0,1-.336-.7.977.977,0,0,1,.166-.7.571.571,0,0,1,.653-.2",
    transform: "translate(-138.675 -102.308)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114889",
    "data-name": "Path 114889",
    d: "M127.962,90.991a6.631,6.631,0,0,1,2.818-3.962,7.383,7.383,0,0,1,3.938-1.381,5.394,5.394,0,0,1,3.875,1.407,4.019,4.019,0,0,1,1.174,2.785l-.082-.719a2.616,2.616,0,0,1-.009,1.811v0c-.12.315-.262.63-.389.946a4.049,4.049,0,0,1-1.922,2.092,2.62,2.62,0,0,1-1.286.313,1.558,1.558,0,0,1-1.165-.567,2.582,2.582,0,0,1-.279-1.843,4.474,4.474,0,0,1-1.4,1.571,1.533,1.533,0,0,1-1.936-.221,2.073,2.073,0,0,1-.011-1.969,3.891,3.891,0,0,1-1.606,1.388,1.433,1.433,0,0,1-1.148.119,1.107,1.107,0,0,1-.6-.77A2.308,2.308,0,0,1,127.962,90.991Z",
    transform: "translate(-126.311 -85.645)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116287",
    "data-name": "Group 116287",
    transform: "translate(5.323 0.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114890",
    "data-name": "Path 114890",
    d: "M130.437,92.913c.047,0,.039-.609.237-1.557a5.927,5.927,0,0,1,1.775-3.224,4.267,4.267,0,0,1,1.779-.96,3.86,3.86,0,0,1,1.656-.041,4.934,4.934,0,0,1,1.432.593c.009-.01-.09-.131-.316-.294a3.206,3.206,0,0,0-1.075-.484,3.841,3.841,0,0,0-1.754-.013,4.332,4.332,0,0,0-1.9,1,5.756,5.756,0,0,0-1.784,3.388,6.822,6.822,0,0,0-.093,1.166A1.205,1.205,0,0,0,130.437,92.913Z",
    transform: "translate(-130.395 -86.838)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114891",
    "data-name": "Path 114891",
    d: "M173.129,195.046l19.769-7.837s10.127-13.281,9.916-13.538l7.108,7.786-10.332,13.987-23.942,5.6-11.339.092C165.187,196.778,173.129,195.046,173.129,195.046Z",
    transform: "translate(-164.31 -128.413)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116301",
    "data-name": "Group 116301",
    transform: "translate(36.894 27.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116293",
    "data-name": "Group 116293",
    transform: "translate(7.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116292",
    "data-name": "Group 116292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116291",
    "data-name": "Group 116291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116290",
    "data-name": "Group 116290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114892",
    "data-name": "Path 114892",
    d: "M106.259,140.572l2.692-1.043L120.581,141v2.055l.333.041a23.789,23.789,0,0,1,7.124,2.766,12.157,12.157,0,0,1,5.675,12.375c-.473,2.941-1.39,6.516-3.156,8.582-3.378,3.951-6.462-.932-6.462-.932s-2.12,4.835-2,7.122a62.267,62.267,0,0,0,1.222,7.152.378.378,0,0,1-.3.452l-24.534,4.536-.12-6,.78-24.664,1.083-9.579S100.19,140.336,106.259,140.572Z",
    transform: "translate(-98.362 -139.529)",
    fill: "#91b3fa"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114893",
    "data-name": "Path 114893",
    d: "M172.427,146.9l-9.354,13.516,7.531,9.174Z",
    transform: "translate(-163.073 -143.11)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116294",
    "data-name": "Group 116294",
    transform: "translate(7.226 10.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114894",
    "data-name": "Path 114894",
    d: "M161.7,181.512a5.465,5.465,0,0,0,.037-.872c.008-.606.017-1.407.03-2.375a73.035,73.035,0,0,1,.56-7.8,77.861,77.861,0,0,1,1.428-7.694l.543-2.313a5.442,5.442,0,0,0,.173-.856,5.468,5.468,0,0,0-.273.829c-.16.538-.377,1.321-.627,2.295a63.816,63.816,0,0,0-1.51,7.7,60.42,60.42,0,0,0-.484,7.835c.01,1,.024,1.817.056,2.378A5.408,5.408,0,0,0,161.7,181.512Z",
    transform: "translate(-161.578 -159.6)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116295",
    "data-name": "Group 116295",
    transform: "translate(30.367 11.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114895",
    "data-name": "Path 114895",
    d: "M98.339,162.159c0,.044.71.034,1.849.1a29.1,29.1,0,0,1,8.685,1.8c1.07.4,1.716.686,1.735.647a1.8,1.8,0,0,0-.43-.254c-.283-.151-.705-.347-1.235-.569a23.9,23.9,0,0,0-8.748-1.812c-.574-.007-1.039.006-1.359.031A1.813,1.813,0,0,0,98.339,162.159Z",
    transform: "translate(-98.339 -162.064)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116296",
    "data-name": "Group 116296",
    transform: "translate(8.699 17.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114896",
    "data-name": "Path 114896",
    d: "M148.614,174.271a4.669,4.669,0,0,0,1.166.253,25.8,25.8,0,0,0,5.743.2,4.636,4.636,0,0,0,1.18-.173,6.111,6.111,0,0,0-1.19-.016c-.732.013-1.743.021-2.858-.016s-2.123-.116-2.852-.179A6.084,6.084,0,0,0,148.614,174.271Z",
    transform: "translate(-148.614 -174.256)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116297",
    "data-name": "Group 116297",
    transform: "translate(4.402 11.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114897",
    "data-name": "Path 114897",
    d: "M164.209,162.384a9.867,9.867,0,0,0,4.367,2.671c.029-.073-1.021-.538-2.22-1.276S164.261,162.324,164.209,162.384Z",
    transform: "translate(-164.207 -162.38)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116298",
    "data-name": "Group 116298",
    transform: "translate(8.184 5.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114898",
    "data-name": "Path 114898",
    d: "M153.936,150.195a9.719,9.719,0,0,0,5.867,2.485c.014-.082-1.416-.3-3.039-.994S153.986,150.127,153.936,150.195Z",
    transform: "translate(-153.935 -150.191)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116299",
    "data-name": "Group 116299",
    transform: "translate(7.674 28.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114899",
    "data-name": "Path 114899",
    d: "M139.894,194.632a2.148,2.148,0,0,0,.486.256c.319.151.791.345,1.384.562a25.446,25.446,0,0,0,9.7,1.489c.631-.029,1.14-.072,1.489-.121a2.135,2.135,0,0,0,.54-.1c0-.044-.78.019-2.034.029a30.146,30.146,0,0,1-9.632-1.48C140.632,194.885,139.911,194.592,139.894,194.632Z",
    transform: "translate(-139.894 -194.629)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116300",
    "data-name": "Group 116300",
    transform: "translate(7.484 35.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114900",
    "data-name": "Path 114900",
    d: "M119.8,208.193a.9.9,0,0,0,.22.124l.651.309c.566.268,1.4.616,2.451,1.009s2.319.806,3.747,1.2a43.84,43.84,0,0,0,9.51,1.476c1.481.059,2.816.053,3.935-.007s2.022-.134,2.642-.219l.714-.1a.871.871,0,0,0,.247-.052.936.936,0,0,0-.252,0l-.718.047c-.622.052-1.524.1-2.639.133s-2.443.022-3.915-.05-3.086-.239-4.768-.495-3.264-.61-4.692-.973-2.695-.766-3.746-1.138-1.9-.688-2.475-.926l-.67-.262A.929.929,0,0,0,119.8,208.193Z",
    transform: "translate(-119.803 -208.191)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116320",
    "data-name": "Group 116320",
    transform: "translate(80.56 172.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116318",
    "data-name": "Group 116318",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116302",
    "data-name": "Group 116302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114901",
    "data-name": "Path 114901",
    d: "M72.333,420.777l2.779,12.562,5.063,9.3a1.318,1.318,0,0,1-.608,1.828h0a1.31,1.31,0,0,1-1.206-.055c-2.355-1.361-11-6.41-11.147-7.341C67.038,436,63.4,424.018,63.4,424.018Z",
    transform: "translate(-63.403 -420.777)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116303",
    "data-name": "Group 116303",
    transform: "translate(3.604 15.453)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114902",
    "data-name": "Path 114902",
    d: "M77.458,459.073,64.9,450.834l.13.529a1.986,1.986,0,0,0,.764,1.138c1.022.738,3.889,2.713,10.423,6.527a1.318,1.318,0,0,0,1.243.045Z",
    transform: "translate(-64.898 -450.834)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116305",
    "data-name": "Group 116305",
    transform: "translate(4.161 10.741)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116304",
    "data-name": "Group 116304",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114903",
    "data-name": "Path 114903",
    d: "M86.317,441.721a.8.8,0,0,1,.46.959.767.767,0,0,1-.947.465.841.841,0,0,1-.482-1.019.8.8,0,0,1,1.039-.374",
    transform: "translate(-85.299 -441.669)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116307",
    "data-name": "Group 116307",
    transform: "translate(11.936 16.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116306",
    "data-name": "Group 116306",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114904",
    "data-name": "Path 114904",
    d: "M68.756,455.77a2.845,2.845,0,0,1,2.228-1.868c0-.033-.178-.092-.481-.061a2.1,2.1,0,0,0-1.723,1.445C68.7,455.579,68.722,455.768,68.756,455.77Z",
    transform: "translate(-68.724 -453.832)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116309",
    "data-name": "Group 116309",
    transform: "translate(13.255 19.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116308",
    "data-name": "Group 116308",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114905",
    "data-name": "Path 114905",
    d: "M66.346,459.166c.072.04.374-.465.975-.809A10.723,10.723,0,0,1,68.5,457.9a1.46,1.46,0,0,0-1.324.213C66.5,458.51,66.273,459.149,66.346,459.166Z",
    transform: "translate(-66.333 -457.827)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116311",
    "data-name": "Group 116311",
    transform: "translate(9.778 14.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116310",
    "data-name": "Group 116310",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114906",
    "data-name": "Path 114906",
    d: "M71.149,452.085a13.21,13.21,0,0,1,1.42-1.35,13.13,13.13,0,0,1,1.748-.886,3.6,3.6,0,0,0-3.168,2.236Z",
    transform: "translate(-71.141 -449.825)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116313",
    "data-name": "Group 116313",
    transform: "translate(8.618 12.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116312",
    "data-name": "Group 116312",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114907",
    "data-name": "Path 114907",
    d: "M73.3,445.925c.052.066.671-.391,1.561-.644s1.656-.211,1.663-.3a3.272,3.272,0,0,0-3.225.94Z",
    transform: "translate(-73.294 -444.859)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116315",
    "data-name": "Group 116315",
    transform: "translate(7.709 8.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116314",
    "data-name": "Group 116314",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114908",
    "data-name": "Path 114908",
    d: "M74.789,438.806a6.455,6.455,0,0,1,1.608-.714,6.444,6.444,0,0,1,1.759.01c.014-.031-.161-.155-.49-.25a2.871,2.871,0,0,0-2.528.529C74.874,438.6,74.764,438.783,74.789,438.806Z",
    transform: "translate(-74.785 -437.755)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116317",
    "data-name": "Group 116317",
    transform: "translate(6.913 5.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116316",
    "data-name": "Group 116316",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114909",
    "data-name": "Path 114909",
    d: "M77.64,434.792a1.107,1.107,0,0,0-.1-.477,3.379,3.379,0,0,0-.679-1.146,1.5,1.5,0,0,0-.795-.542.529.529,0,0,0-.552.257.863.863,0,0,0-.06.612,1.864,1.864,0,0,0,2,1.285,2.162,2.162,0,0,0,1.792-1.6.749.749,0,0,0-.114-.614.52.52,0,0,0-.594-.138,1.847,1.847,0,0,0-.718.63,3.782,3.782,0,0,0-.614,1.18,1.144,1.144,0,0,0-.086.479,6,6,0,0,1,.856-1.533,1.724,1.724,0,0,1,.64-.534.276.276,0,0,1,.324.073.514.514,0,0,1,.051.408,1.929,1.929,0,0,1-1.57,1.372,1.618,1.618,0,0,1-1.711-1.067.628.628,0,0,1,.023-.429.288.288,0,0,1,.3-.146,1.353,1.353,0,0,1,.681.447A4.992,4.992,0,0,1,77.64,434.792Z",
    transform: "translate(-75.427 -432.387)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116319",
    "data-name": "Group 116319",
    transform: "translate(0 0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114910",
    "data-name": "Path 114910",
    d: "M86.422,422.14l.6,2.881-9.1,1.509-.759-2.512,8.93-3.24Z",
    transform: "translate(-77.168 -420.777)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116339",
    "data-name": "Group 116339",
    transform: "translate(39.592 176.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116333",
    "data-name": "Group 116333",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116321",
    "data-name": "Group 116321",
    transform: "translate(0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114911",
    "data-name": "Path 114911",
    d: "M147.283,429.437l.751,10.038s-9.951,4.134-9.993,6l19.515-.757-.528-15.688Z",
    transform: "translate(-138.041 -429.032)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116323",
    "data-name": "Group 116323",
    transform: "translate(15.079 9.336)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116322",
    "data-name": "Group 116322",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114912",
    "data-name": "Path 114912",
    d: "M144.653,447.217a.8.8,0,0,1,.587.888.767.767,0,0,1-.876.589.842.842,0,0,1-.616-.944.8.8,0,0,1,.978-.512",
    transform: "translate(-143.726 -447.19)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116324",
    "data-name": "Group 116324",
    transform: "translate(0 14.109)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114913",
    "data-name": "Path 114913",
    d: "M157.568,458.054l-.115-1.579-18.668,1.316s-.854.412-.732,1.02Z",
    transform: "translate(-138.041 -456.475)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116326",
    "data-name": "Group 116326",
    transform: "translate(9.684 10.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116325",
    "data-name": "Group 116325",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114914",
    "data-name": "Path 114914",
    d: "M153.646,449.078c.007.1.485.12.966.408s.747.679.832.638c.087-.022-.077-.586-.665-.925S153.622,448.991,153.646,449.078Z",
    transform: "translate(-153.645 -448.977)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116328",
    "data-name": "Group 116328",
    transform: "translate(7.67 11.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116327",
    "data-name": "Group 116327",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114915",
    "data-name": "Path 114915",
    d: "M158.489,450.934c-.019.093.4.239.74.63s.449.813.544.805c.09.011.135-.549-.3-1.027S158.488,450.843,158.489,450.934Z",
    transform: "translate(-158.489 -450.891)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116330",
    "data-name": "Group 116330",
    transform: "translate(5.778 12.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116329",
    "data-name": "Group 116329",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114916",
    "data-name": "Path 114916",
    d: "M163.807,454.3c.087.017.2-.464-.063-.977s-.719-.7-.756-.622.249.349.461.773S163.712,454.294,163.807,454.3Z",
    transform: "translate(-162.982 -452.683)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116332",
    "data-name": "Group 116332",
    transform: "translate(9.763 7.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116331",
    "data-name": "Group 116331",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114917",
    "data-name": "Path 114917",
    d: "M153.074,444.328c.043.085.476-.063,1.015-.047s.967.169,1.013.085-.37-.408-1.007-.417S153.024,444.255,153.074,444.328Z",
    transform: "translate(-153.07 -443.948)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116334",
    "data-name": "Group 116334",
    transform: "translate(9.405 1.654)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114918",
    "data-name": "Path 114918",
    d: "M138.824,432.987l.131,1.789,9.588-.459-.065-2.068Z",
    transform: "translate(-138.824 -432.248)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116336",
    "data-name": "Group 116336",
    transform: "translate(9.653 4.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116335",
    "data-name": "Group 116335",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114919",
    "data-name": "Path 114919",
    d: "M151.56,439.167a1.837,1.837,0,0,0,.977-.043,4.384,4.384,0,0,0,1.01-.354,4.651,4.651,0,0,0,.55-.319,1.225,1.225,0,0,0,.286-.242.416.416,0,0,0,.024-.508.522.522,0,0,0-.426-.2,1.267,1.267,0,0,0-.365.065,3.513,3.513,0,0,0-.6.232,3.447,3.447,0,0,0-.878.627c-.436.437-.577.8-.544.816s.253-.277.7-.641a3.888,3.888,0,0,1,.852-.525,3.637,3.637,0,0,1,.554-.195c.2-.062.38-.07.437.019.021.034.024.048-.017.111a.993.993,0,0,1-.211.176,5.136,5.136,0,0,1-.5.315,5.386,5.386,0,0,1-.931.4A6.686,6.686,0,0,0,151.56,439.167Z",
    transform: "translate(-151.56 -437.499)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116338",
    "data-name": "Group 116338",
    transform: "translate(8.416 3.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116337",
    "data-name": "Group 116337",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114920",
    "data-name": "Path 114920",
    d: "M157.93,438.1a1.563,1.563,0,0,0,.221-.954,3.193,3.193,0,0,0-.175-1.065,3.236,3.236,0,0,0-.272-.584.809.809,0,0,0-.643-.469.457.457,0,0,0-.4.288,1.318,1.318,0,0,0-.087.362,2.18,2.18,0,0,0,.025.658,2.245,2.245,0,0,0,.457.993c.4.491.8.59.81.557.03-.049-.31-.22-.62-.695a2.257,2.257,0,0,1-.345-.906,2,2,0,0,1,0-.566c.022-.209.094-.379.172-.361.1-.005.268.145.354.307a3.3,3.3,0,0,1,.263.52,3.523,3.523,0,0,1,.227.968C157.966,437.723,157.878,438.084,157.93,438.1Z",
    transform: "translate(-156.564 -435.024)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116345",
    "data-name": "Group 116345",
    transform: "translate(40.248 67.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114921",
    "data-name": "Path 114921",
    d: "M103.033,217.992s3.1.136,5.14,10.687,17.735,96.036,17.735,96.036l-11.366.1L93.1,243.544l1.425,83.785-11.548.883s-8.665-92.692-8.746-98.084c-.1-6.724,3.76-13.525,3.76-13.525Z",
    transform: "translate(-74.23 -216.603)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116340",
    "data-name": "Group 116340",
    transform: "translate(13.178 0.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114922",
    "data-name": "Path 114922",
    d: "M138.347,217.547c-.073.015,1.107,6.043,2.634,13.462s2.824,13.424,2.9,13.409-1.107-6.042-2.634-13.463S138.42,217.532,138.347,217.547Z",
    transform: "translate(-138.344 -217.547)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116341",
    "data-name": "Group 116341",
    transform: "translate(10.438 1.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114923",
    "data-name": "Path 114923",
    d: "M151.813,220.442c.02-.026-.308-.123-.66.192a.952.952,0,0,0-.31.727.961.961,0,0,0,1.547.652.952.952,0,0,0,.3-.73c-.021-.472-.319-.639-.324-.607a1.409,1.409,0,0,1,.135.6.8.8,0,0,1-.275.547.739.739,0,0,1-1.141-.481.8.8,0,0,1,.2-.578C151.539,220.476,151.819,220.486,151.813,220.442Z",
    transform: "translate(-150.843 -220.407)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116342",
    "data-name": "Group 116342",
    transform: "translate(11.334 6.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114924",
    "data-name": "Path 114924",
    d: "M149.877,228.554c.007-.032-.32.011-.5.428a.9.9,0,0,0,.032.757.906.906,0,0,0,1.595-.124.9.9,0,0,0-.086-.752c-.241-.385-.57-.377-.558-.346-.017.04.242.1.391.434a.747.747,0,0,1,.023.575.682.682,0,0,1-1.151.089.747.747,0,0,1-.066-.572C149.654,228.694,149.9,228.591,149.877,228.554Z",
    transform: "translate(-149.31 -228.503)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116343",
    "data-name": "Group 116343",
    transform: "translate(22.79 2.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114925",
    "data-name": "Path 114925",
    d: "M109.664,220.681a1.911,1.911,0,0,0,.135.529,8.666,8.666,0,0,0,.6,1.361,10,10,0,0,0,7.908,5.212,8.693,8.693,0,0,0,1.487.014,1.884,1.884,0,0,0,.539-.084c0-.05-.776.037-2.005-.118a10.439,10.439,0,0,1-7.764-5.117C109.936,221.409,109.711,220.663,109.664,220.681Z",
    transform: "translate(-109.661 -220.68)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116344",
    "data-name": "Group 116344",
    transform: "translate(0.676 0.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114926",
    "data-name": "Path 114926",
    d: "M166.247,226.861c.011.015.132-.059.341-.205a6.08,6.08,0,0,0,.824-.706,8.761,8.761,0,0,0,2.515-6.526,6.092,6.092,0,0,0-.138-1.076,1.136,1.136,0,0,0-.115-.381c-.048.009.062.563.064,1.462a9.552,9.552,0,0,1-2.463,6.391C166.67,226.485,166.217,226.822,166.247,226.861Z",
    transform: "translate(-166.245 -217.966)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116357",
    "data-name": "Group 116357",
    transform: "translate(47.909 20.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116354",
    "data-name": "Group 116354",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116352",
    "data-name": "Group 116352",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116348",
    "data-name": "Group 116348",
    transform: "translate(0.109 0.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116347",
    "data-name": "Group 116347",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114927",
    "data-name": "Path 114927",
    d: "M125.317,153.565l-5.05.279a25.423,25.423,0,0,1-1.428,4.14,83.922,83.922,0,0,1-8-20.308c.114-.379.249-.8.417-1.268a5.387,5.387,0,0,0-.064-2.136c-.136-.846-.373-1.984-.444-2.511-.217-1.605-.475-1.858-1.035-1.676-.761.247.313,4.508-.312,4.6-.336.05-.746-1.41-.865-2.608s-.661-4.883-1.057-5.128c-.58-.36-1.086.21-.94,1.4s.335,4.808-.3,4.857-1.148-6.061-1.148-6.061.1-1.329-.634-1.3c-1.322.057-.289,6.5-.176,7.108.079.425-.608.5-.668.042s-.381-6.109-1.727-6.064c-1.033.035.8,5.307.221,6.53s-.983-4.151-1.97-4.077c-.367.028-.639.1.036,3.14a68.818,68.818,0,0,0,2.359,7.127c1.564,8.431,8.424,35.4,19.18,30.467,6.018-2.763,8.827-16.442,8.827-16.442Z",
    transform: "translate(-99.765 -125.849)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116351",
    "data-name": "Group 116351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116350",
    "data-name": "Group 116350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116349",
    "data-name": "Group 116349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114928",
    "data-name": "Path 114928",
    d: "M139.88,139.513a.87.87,0,0,0-.051-.185l-.18-.531-.7-2.035c-.3-.885-.668-1.969-1.034-3.243-.188-.636-.339-1.324-.481-2.063-.068-.369-.138-.749-.181-1.139a3.935,3.935,0,0,1-.027-.585c.014-.2.045-.364.2-.367.164-.044.274.091.386.262a3.172,3.172,0,0,1,.255.57c.144.405.257.836.369,1.277s.215.9.35,1.357a2.117,2.117,0,0,0,.308.709.277.277,0,0,0,.141.085.237.237,0,0,0,.193-.043.62.62,0,0,0,.142-.194,1.353,1.353,0,0,0,.108-.392,12.626,12.626,0,0,0-.3-3.065c-.088-.516-.181-1.039-.249-1.567a7.153,7.153,0,0,1-.064-.793c-.01-.244.033-.573.139-.62.132-.05.37.1.5.317a3.262,3.262,0,0,1,.337.729,11.221,11.221,0,0,1,.4,1.645c.1.566.175,1.143.238,1.728q.043.44.086.883l.039.447a.664.664,0,0,0,.2.518.526.526,0,0,0,.608.024.426.426,0,0,0,.185-.293.548.548,0,0,0,0-.165l-.02-.11q-.069-.447-.137-.9c-.085-.6-.158-1.214-.217-1.829s-.1-1.237-.11-1.861a6.2,6.2,0,0,1,.181-1.829.627.627,0,0,1,.26-.372.322.322,0,0,1,.347.111,1.718,1.718,0,0,1,.193,1v.026c.11,1.208.241,2.4.415,3.563.09.583.185,1.161.332,1.732.037.143.08.285.131.428a.9.9,0,0,0,.291.444.313.313,0,0,0,.378-.083.742.742,0,0,0,.14-.232,2.267,2.267,0,0,0,.116-.443,16.607,16.607,0,0,0,.03-3.368,9.245,9.245,0,0,1-.083-1.576.865.865,0,0,1,.287-.586.325.325,0,0,1,.263-.041.626.626,0,0,1,.143.061.179.179,0,0,1,.072.089,7.038,7.038,0,0,1,.405,1.431c.1.492.188.981.266,1.464s.148.96.209,1.43.1.938.188,1.4a7.52,7.52,0,0,0,.36,1.33,2.621,2.621,0,0,0,.149.316c.072.1.113.223.31.283a.26.26,0,0,0,.261-.11.674.674,0,0,0,.081-.19,1.9,1.9,0,0,0,.041-.342c.011-.876-.119-1.68-.162-2.456a6.035,6.035,0,0,1,0-1.117c.023-.165.076-.359.17-.4a.477.477,0,0,1,.419-.009,1.483,1.483,0,0,1,.38.842c.072.318.105.633.164.937.214,1.216.441,2.26.551,3.114a4.153,4.153,0,0,1,.016,1.132c-.071.312-.175.587-.235.8l-.148.5a.089.089,0,1,0,.03.009l.176-.486c.071-.22.179-.47.267-.805a4.121,4.121,0,0,0,.013-1.163c-.093-.869-.3-1.905-.5-3.124-.055-.3-.084-.625-.155-.952a3.668,3.668,0,0,0-.135-.5.906.906,0,0,0-.322-.471.667.667,0,0,0-.607-.008c-.241.138-.25.369-.292.551a6.2,6.2,0,0,0-.016,1.16c.038.78.16,1.6.142,2.431a1.665,1.665,0,0,1-.036.295c-.022.1-.074.138-.063.119-.019,0-.1-.085-.141-.166a2.4,2.4,0,0,1-.131-.284,7.355,7.355,0,0,1-.338-1.285c-.086-.444-.114-.908-.177-1.385s-.126-.954-.2-1.44-.161-.979-.261-1.478a6.983,6.983,0,0,0-.43-1.517.49.49,0,0,0-.18-.2.914.914,0,0,0-.216-.09.621.621,0,0,0-.491.077,1.13,1.13,0,0,0-.42.786,3.126,3.126,0,0,0,0,.84c.03.264.052.532.071.8a16.522,16.522,0,0,1-.036,3.293,1.976,1.976,0,0,1-.1.381.446.446,0,0,1-.077.133.052.052,0,0,1-.026.021h0v0c.009.121,0,.026,0,.049,0-.022.007-.018.021-.044a.972.972,0,0,1-.149-.282c-.045-.129-.086-.262-.121-.4-.14-.549-.234-1.123-.322-1.7-.171-1.157-.3-2.343-.41-3.543v.025a1.964,1.964,0,0,0-.26-1.219.637.637,0,0,0-.717-.21.9.9,0,0,0-.442.563,6.4,6.4,0,0,0-.2,1.939c.01.636.054,1.265.113,1.886s.134,1.236.221,1.844q.07.456.14.907c.038.191.029.2-.028.254a.217.217,0,0,1-.239-.009c-.066-.044-.074-.134-.087-.3l-.04-.446q-.045-.447-.089-.888c-.065-.589-.143-1.172-.245-1.747a11.44,11.44,0,0,0-.412-1.69,3.527,3.527,0,0,0-.374-.8,1.153,1.153,0,0,0-.33-.341.572.572,0,0,0-.535-.077.6.6,0,0,0-.28.453,2.4,2.4,0,0,0-.027.437,7.45,7.45,0,0,0,.069.827c.071.54.168,1.063.259,1.579a12.666,12.666,0,0,1,.318,2.98,1.118,1.118,0,0,1-.082.314.472.472,0,0,1-.066.1c0-.006,0-.009.012.023s0-.009.005,0c.02-.032.005-.023,0-.034a2.1,2.1,0,0,1-.252-.6c-.134-.448-.241-.9-.356-1.345s-.232-.878-.385-1.3a3.419,3.419,0,0,0-.281-.61,1.034,1.034,0,0,0-.234-.272.482.482,0,0,0-.183-.091.575.575,0,0,0-.2,0,.4.4,0,0,0-.324.238.981.981,0,0,0-.066.34,4.08,4.08,0,0,0,.034.621c.048.4.123.783.2,1.154.15.739.312,1.438.509,2.074.385,1.276.77,2.354,1.088,3.234s.58,1.558.76,2.016l.21.52A.867.867,0,0,0,139.88,139.513Z",
    transform: "translate(-136.998 -125.549)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116353",
    "data-name": "Group 116353",
    transform: "translate(19.183 23.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114929",
    "data-name": "Path 114929",
    d: "M111.416,176.544c-.977,3.447-2.885,8.772-4.937,14.387a.974.974,0,0,1-1.795.083l-5.03-10.634s1.211-8.737,1.108-8.428,10.378,1.13,10.378,1.13Z",
    transform: "translate(-99.654 -171.943)",
    fill: "#91b3fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116355",
    "data-name": "Group 116355",
    transform: "translate(19.617 26.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114930",
    "data-name": "Path 114930",
    d: "M102.277,177.553c-.011.043.625.227,1.621.607a22.765,22.765,0,0,1,7.071,4.288c.8.707,1.255,1.186,1.287,1.157a1.584,1.584,0,0,0-.282-.374c-.193-.231-.492-.548-.877-.922a19.106,19.106,0,0,0-7.136-4.328c-.511-.169-.929-.287-1.223-.351A1.581,1.581,0,0,0,102.277,177.553Z",
    transform: "translate(-102.277 -177.548)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116356",
    "data-name": "Group 116356",
    transform: "translate(17.62 20.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114931",
    "data-name": "Path 114931",
    d: "M118.61,174.583a5.436,5.436,0,0,0,.839-1.1,18.256,18.256,0,0,0,2.544-6.139,5.44,5.44,0,0,0,.184-1.37,9.984,9.984,0,0,0-.368,1.325,24.3,24.3,0,0,1-2.522,6.084A10.078,10.078,0,0,0,118.61,174.583Z",
    transform: "translate(-118.608 -165.976)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116360",
    "data-name": "Group 116360",
    transform: "translate(61.073 0.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114932",
    "data-name": "Path 114932",
    d: "M118.216,90.115a11.31,11.31,0,0,1,.982,9.67c-.516,1.412-1.335,2.808-1.185,4.306.153,1.536,1.318,2.986.906,4.471-.243.878-1,1.53-1.286,2.393a6.838,6.838,0,0,0,.176,3.169c.411,2.693-.45,5.4-.663,8.116s.519,5.9,2.942,7.08a2.121,2.121,0,0,0,2.311-.085c.777-.7.561-1.949.348-2.978-2.129-10.293,4.447-20.318,2.945-30.723-.241-1.667-1.172-4.5-2.373-5.664s-4.521-1.025-5.658.206",
    transform: "translate(-117.112 -88.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116358",
    "data-name": "Group 116358",
    transform: "translate(1.818 0.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114933",
    "data-name": "Path 114933",
    d: "M121.806,119.245c.021-.018-.309-.371-.772-1.1a9.883,9.883,0,0,1-1.343-3.367,10.008,10.008,0,0,1-.158-2.5,27.21,27.21,0,0,0,.106-2.921,6.252,6.252,0,0,0-.3-1.575,8.642,8.642,0,0,0-.706-1.51c-.575-.973-1.3-1.879-1.971-2.847a7.8,7.8,0,0,1-1.4-3.065,9.614,9.614,0,0,1,.179-3.155,11.744,11.744,0,0,0,.227-2.922,9.823,9.823,0,0,0-.493-2.508,9.63,9.63,0,0,0-1.817-3.2,7.12,7.12,0,0,0-.7-.718,1.737,1.737,0,0,0-.27-.221c-.02.021.347.336.89,1.006A9.987,9.987,0,0,1,115,91.833a9.8,9.8,0,0,1,.451,2.462,11.676,11.676,0,0,1-.248,2.868,9.732,9.732,0,0,0-.195,3.238,7.99,7.99,0,0,0,1.437,3.174c.676.98,1.4,1.88,1.966,2.829a8.445,8.445,0,0,1,.689,1.458,6.033,6.033,0,0,1,.292,1.51,28.034,28.034,0,0,1-.082,2.9,10.025,10.025,0,0,0,.195,2.548,9.517,9.517,0,0,0,1.442,3.386,8.3,8.3,0,0,0,.613.794A1.675,1.675,0,0,0,121.806,119.245Z",
    transform: "translate(-112.392 -87.634)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116359",
    "data-name": "Group 116359",
    transform: "translate(2.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114934",
    "data-name": "Path 114934",
    d: "M117,119.932a2.05,2.05,0,0,0-.159-.344l-.5-.966c-.43-.839-1.075-2.044-1.708-3.6a15.669,15.669,0,0,1-1.256-5.713,10.5,10.5,0,0,1,.125-1.687c.088-.571.221-1.154.307-1.762a4.962,4.962,0,0,0-.039-1.891,3.407,3.407,0,0,0-1.046-1.65c-.97-.881-2.138-1.455-2.742-2.486a8.433,8.433,0,0,1-.912-3.3,13.049,13.049,0,0,0-.708-3.106,11.089,11.089,0,0,0-4.162-5.253,8.206,8.206,0,0,0-.941-.551,2.014,2.014,0,0,0-.347-.156c-.014.026.461.25,1.228.793A11.23,11.23,0,0,1,106.9,91.08,10.881,10.881,0,0,1,108.15,93.5a12.977,12.977,0,0,1,.671,3.061,8.588,8.588,0,0,0,.933,3.4c.655,1.111,1.865,1.7,2.784,2.545a3.146,3.146,0,0,1,.971,1.521,4.722,4.722,0,0,1,.037,1.788c-.082.594-.212,1.176-.3,1.759a10.713,10.713,0,0,0-.119,1.728,15.559,15.559,0,0,0,1.327,5.784,35.235,35.235,0,0,0,1.792,3.58l.544.941A1.979,1.979,0,0,0,117,119.932Z",
    transform: "translate(-102.908 -87.464)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(308.981 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116472",
    "data-name": "Group 116472",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116471",
    "data-name": "Group 116471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114980",
    "data-name": "Path 114980",
    d: "M72.483,96.1l-10.54-2.59.078-.013a17.524,17.524,0,0,1-9.1,2.728,19.041,19.041,0,0,1-5.638-.823,17.43,17.43,0,0,1-5.494-2.913,17.659,17.659,0,0,1-6.648-11.747,17.446,17.446,0,0,1,4.529-14.072,18.314,18.314,0,0,1,3.053-2.659c.57-.352,1.132-.718,1.719-1.027l.9-.432.447-.214.464-.17a17.775,17.775,0,0,1,7.578-1.154A17.545,17.545,0,0,1,69.3,72.82a18.172,18.172,0,0,1,.973,5.69,17.471,17.471,0,0,1-2.525,9.13v-.1l4.738,8.55-4.9-8.457-.027-.047.028-.048a17.362,17.362,0,0,0,2.432-9.032,17.979,17.979,0,0,0-.986-5.6A17.269,17.269,0,0,0,53.806,61.348a17.478,17.478,0,0,0-7.43,1.14l-.455.167-.438.211-.878.423c-.575.3-1.126.663-1.684,1.008A17.985,17.985,0,0,0,39.929,66.9,17.306,17.306,0,0,0,41.98,92.242a17.178,17.178,0,0,0,5.391,2.883,18.833,18.833,0,0,0,5.546.835,17.382,17.382,0,0,0,9-2.635l.037-.023.041.011Z",
    transform: "translate(-35.012 -60.971)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_114981",
    "data-name": "Path 114981",
    d: "M61.959,76.487l.557,8.8a1.429,1.429,0,0,0,1.341,1.336h0a1.429,1.429,0,0,0,1.5-1.269l.978-8.849a1.121,1.121,0,0,0-1.129-1.244l-2.148.03A1.121,1.121,0,0,0,61.959,76.487Z",
    transform: "translate(-46.379 -66.682)",
    fill: "#ff6363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114982",
    "data-name": "Path 114982",
    d: "M66.222,100.555a2.149,2.149,0,1,1-1.362-2.717A2.149,2.149,0,0,1,66.222,100.555Z",
    transform: "translate(-46.409 -75.658)",
    fill: "#ff6363"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(123.739 145.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115782",
    "data-name": "Group 115782",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115781",
    "data-name": "Group 115781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115777",
    "data-name": "Group 115777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115767",
    "data-name": "Group 115767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115763",
    "data-name": "Group 115763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115757",
    "data-name": "Group 115757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115756",
    "data-name": "Group 115756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115755",
    "data-name": "Group 115755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115754",
    "data-name": "Group 115754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115753",
    "data-name": "Group 115753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114578",
    "data-name": "Path 114578",
    d: "M323.052,100.587H151.9a5.342,5.342,0,0,0-5.342,5.342V226.815a5.342,5.342,0,0,0,5.342,5.343H217.59s4.178,12.92-8.775,19.606h61.42s-14.624-5.014-10.864-19.606h63.681a5.343,5.343,0,0,0,5.342-5.342V105.929A5.342,5.342,0,0,0,323.052,100.587Z",
    transform: "translate(-146.561 -100.587)",
    fill: "#11548f"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115762",
    "data-name": "Group 115762",
    transform: "translate(87.539 117.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115761",
    "data-name": "Group 115761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115760",
    "data-name": "Group 115760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115759",
    "data-name": "Group 115759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115758",
    "data-name": "Group 115758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114579",
    "data-name": "Path 114579",
    d: "M369.554,393.4a3.3,3.3,0,0,1-4.644,4.643,1.18,1.18,0,0,1-.286-.287,3.3,3.3,0,0,1,4.643-4.643A1.173,1.173,0,0,1,369.554,393.4Z",
    transform: "translate(-363.891 -392.385)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115766",
    "data-name": "Group 115766",
    transform: "translate(2.947 1.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115765",
    "data-name": "Group 115765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115764",
    "data-name": "Group 115764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22408",
    "data-name": "Rectangle 22408",
    d: "M9.7,0H166.243a9.7,9.7,0,0,1,9.7,9.7v97.544a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9.7A9.7,9.7,0,0,1,9.7,0Z",
    fill: "#c5c5c5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115769",
    "data-name": "Group 115769",
    transform: "translate(2.947 1.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115768",
    "data-name": "Group 115768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22409",
    "data-name": "Rectangle 22409",
    d: "M8.911,0H168.623a7.317,7.317,0,0,1,7.317,7.317V8.911a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.911,8.911,0,0,1,8.911,0Z",
    fill: "#686868"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115776",
    "data-name": "Group 115776",
    transform: "translate(7.314 5.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115771",
    "data-name": "Group 115771",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115770",
    "data-name": "Group 115770"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 1.236,
    cy: 1.236,
    r: 1.236,
    fill: "#11548f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115773",
    "data-name": "Group 115773",
    transform: "translate(3.685 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115772",
    "data-name": "Group 115772"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    cx: 1.236,
    cy: 1.236,
    r: 1.236,
    fill: "#11548f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115775",
    "data-name": "Group 115775",
    transform: "translate(7.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115774",
    "data-name": "Group 115774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114580",
    "data-name": "Path 114580",
    d: "M185.036,115.025a1.236,1.236,0,1,1-1.236-1.236A1.236,1.236,0,0,1,185.036,115.025Z",
    transform: "translate(-182.564 -113.789)",
    fill: "#11548f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115780",
    "data-name": "Group 115780",
    transform: "translate(37.106 131.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115779",
    "data-name": "Group 115779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115778",
    "data-name": "Group 115778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114581",
    "data-name": "Path 114581",
    d: "M347.47,426.372c0,.057-24.355.1-54.391.1s-54.4-.046-54.4-.1,24.35-.1,54.4-.1S347.47,426.315,347.47,426.372Z",
    transform: "translate(-238.683 -426.269)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116562",
    "data-name": "Group 116562",
    transform: "translate(67.023 96.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116561",
    "data-name": "Group 116561",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116540",
    "data-name": "Group 116540",
    transform: "translate(0 13.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116520",
    "data-name": "Group 116520",
    transform: "translate(0 165.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116518",
    "data-name": "Group 116518",
    transform: "translate(1.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115001",
    "data-name": "Path 115001",
    d: "M655.025,2327.457s-.6,4.381-.964,7.6,9.327,7.513,11.121.072l2.125-10.031S657.415,2321.847,655.025,2327.457Z",
    transform: "translate(-654.051 -2324.162)",
    fill: "#fccac3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116519",
    "data-name": "Group 116519",
    transform: "translate(0 10.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115002",
    "data-name": "Path 115002",
    d: "M644.71,2409.542c4.814-.266,6.009,3.02,10.357,0,2.856,0,7.549,3.5,9.229,5.046s4.515,4.05-2.523,4.05H645.44c-3.785,0-1.461-5.178-.73-9.1Z",
    transform: "translate(-643.333 -2409.527)",
    fill: "#353640"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116523",
    "data-name": "Group 116523",
    transform: "translate(45.096 165.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116521",
    "data-name": "Group 116521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115003",
    "data-name": "Path 115003",
    d: "M1009.374,2326.9s.6,4.382.964,7.6-9.327,7.513-11.121.072l-2.126-10.031s9.893-3.254,12.284,2.357Z",
    transform: "translate(-997.09 -2323.601)",
    fill: "#fccac3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116522",
    "data-name": "Group 116522",
    transform: "translate(1.537 10.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115004",
    "data-name": "Path 115004",
    d: "M1009.738,2409.465c9.428,4.547,7.246-.432,11.607,0,3.076,0,20.977,9.1,7.514,9.1h-16.312C1008.307,2418.56,1008.92,2413.382,1009.738,2409.465Z",
    transform: "translate(-1009.149 -2409.438)",
    fill: "#353640"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116524",
    "data-name": "Group 116524",
    transform: "translate(0.778 74.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115005",
    "data-name": "Path 115005",
    d: "M661.336,1615.1s-2.868,4.645-4.329,16.861-7.568,79.008-7.568,79.008h12.747l23.238-95.87s-10.092-12.087-24.088,0Z",
    transform: "translate(-649.439 -1609.728)",
    fill: "#353640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116525",
    "data-name": "Group 116525",
    transform: "translate(24.357 74.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115006",
    "data-name": "Path 115006",
    d: "M838.322,1650.625l8.486-35.009a16.615,16.615,0,0,0-10.183-5.3,8.979,8.979,0,0,0-2.209,6.256c-.222,8.76,2.05,22.524,3.906,34.049Z",
    transform: "translate(-834.401 -1610.32)",
    fill: "#2a1d19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116526",
    "data-name": "Group 116526",
    transform: "translate(23.252 70.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115007",
    "data-name": "Path 115007",
    d: "M848.889,1587.985s4.3,12.479,5.763,23.5,7.169,70.908,7.169,70.908l-13.743,1.527s-6.838-36.982-9.1-47.339-11.553-35.048-13.147-48.6S842.17,1576.694,848.889,1587.985Z",
    transform: "translate(-825.736 -1578.651)",
    fill: "#353640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116527",
    "data-name": "Group 116527",
    transform: "translate(0.087 1.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115008",
    "data-name": "Path 115008",
    d: "M654.285,1080.984s-6.947-12.862-9.071-17.244-1.595-8.7,3.053-13.745,11.993-13.562,11.993-13.562a6.535,6.535,0,0,1,5.976,1.461,3.829,3.829,0,0,1,.4,5.178l-10.4,13.7,8.928,9.985S670.087,1080.454,654.285,1080.984Z",
    transform: "translate(-644.019 -1036.235)",
    fill: "#7da3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116528",
    "data-name": "Group 116528",
    transform: "translate(17.273 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115009",
    "data-name": "Path 115009",
    d: "M778.836,1027.351s3.087-2.622,6.075-3.087,6.341,1.428,6.705,2.059-.53,1.958-1.395,2.024-5.776.066-5.776.066a2.424,2.424,0,0,1-1.095,1.162c-.8.4-4.648.133-4.515-2.224Z",
    transform: "translate(-778.833 -1024.191)",
    fill: "#fccac3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116535",
    "data-name": "Group 116535",
    transform: "translate(13.162 0.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116531",
    "data-name": "Group 116531",
    transform: "translate(12.128 22.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116529",
    "data-name": "Group 116529",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22457",
    "data-name": "Rectangle 22457",
    width: 8.166,
    height: 9.029,
    fill: "#fccac3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116530",
    "data-name": "Group 116530",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115010",
    "data-name": "Path 115010",
    d: "M841.72,1211.24h8.167v6.133a10.118,10.118,0,0,1-8.167-3.53Z",
    transform: "translate(-841.72 -1211.24)",
    fill: "#f59a8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116534",
    "data-name": "Group 116534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116532",
    "data-name": "Group 116532",
    transform: "translate(4.032 5.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115011",
    "data-name": "Path 115011",
    d: "M796.566,1079.861s3.187,9.495,1.859,12.88-7.1,5.577-15.2-.929-5.246-14.341.6-16.068S793.91,1074.35,796.566,1079.861Z",
    transform: "translate(-778.213 -1074.819)",
    fill: "#fccac3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116533",
    "data-name": "Group 116533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115012",
    "data-name": "Path 115012",
    d: "M756.683,1035.461a51.947,51.947,0,0,0,9.428-3.187c4.582-2.125,9.621,8.67,3.085,10.941s-5.409,6.32-5.409,6.32-3.917-1.792-5.079-.265,1.128,5.875,5.577,3.718c0,0-1.161,4.748-5.312,4.781s-15.933-11.021-11.353-15.27C747.621,1042.5,743.9,1036.989,756.683,1035.461Z",
    transform: "translate(-746.581 -1031.999)",
    fill: "#353640"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116536",
    "data-name": "Group 116536",
    transform: "translate(10.287 31.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115013",
    "data-name": "Path 115013",
    d: "M726.421,1321.957H760.15s1.991-15.8,3.319-30.143-7.7-16.068-7.7-16.068-8.1-3.452-25.629-1.261c0,0-5.511,7.237-6.041,13.743S726.421,1321.957,726.421,1321.957Z",
    transform: "translate(-724.032 -1273.757)",
    fill: "#7da3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116537",
    "data-name": "Group 116537",
    transform: "translate(39.153 50.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115014",
    "data-name": "Path 115014",
    d: "M954.782,1450.343h2.94s1.927-15.293,3.254-29.443l-10.507,1.09a6.339,6.339,0,0,1,5.776,7.038C956,1433.585,955.227,1444.263,954.782,1450.343Z",
    transform: "translate(-950.47 -1420.9)",
    fill: "#647edd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116538",
    "data-name": "Group 116538",
    transform: "translate(34.28 3.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115015",
    "data-name": "Path 115015",
    d: "M922.461,1059.965s-3.253-.8-5.908-1.428-2.657-2.324,1-2.523c0,0-4.515-3.385-5.244-5.045s5.311-2.557,7.7-1.959,5.645,5.643,5.645,5.643l2.091,1.494-5.279,3.818Z",
    transform: "translate(-912.243 -1048.824)",
    fill: "#fccac3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116539",
    "data-name": "Group 116539",
    transform: "translate(35.951 8.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115016",
    "data-name": "Path 115016",
    d: "M939.062,1135.262c4.41-1.569,11.231-3.947,17.259-5.854,10.49-3.319,9.76-12.416,2.191-19.055s-20.447-16.823-20.447-16.823l-5.511,5.445,14.007,17.353-17.826,1.367c-8.211,8.192-.18,18.657,10.327,17.567Z",
    transform: "translate(-925.354 -1093.53)",
    fill: "#7da3fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116544",
    "data-name": "Group 116544",
    transform: "translate(17.244 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116541",
    "data-name": "Group 116541",
    transform: "translate(0 2.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115017",
    "data-name": "Path 115017",
    d: "M781.923,946.382a.266.266,0,0,1-.241-.153l-3.053-6.506a.266.266,0,0,1,.481-.226L782.164,946a.266.266,0,0,1-.24.379Z",
    transform: "translate(-778.604 -939.344)",
    fill: "#ff6363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116542",
    "data-name": "Group 116542",
    transform: "translate(11.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115018",
    "data-name": "Path 115018",
    d: "M870.011,927.411H870a.266.266,0,0,1-.251-.28l.465-8.365a.266.266,0,1,1,.531.03l-.465,8.365A.266.266,0,0,1,870.011,927.411Z",
    transform: "translate(-869.745 -918.514)",
    fill: "#ff6363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116543",
    "data-name": "Group 116543",
    transform: "translate(19.652 7.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115019",
    "data-name": "Path 115019",
    d: "M933.031,977.755a.266.266,0,0,1-.138-.493l4.914-2.988a.266.266,0,1,1,.276.454l-4.914,2.988A.265.265,0,0,1,933.031,977.755Z",
    transform: "translate(-932.765 -974.235)",
    fill: "#ff6363"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116578",
    "data-name": "Group 116578",
    transform: "translate(-10.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115655",
    "data-name": "Group 115655",
    transform: "translate(170.064 42.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114366",
    "data-name": "Path 114366",
    d: "M101.834,186.752a10.567,10.567,0,0,1,16-7.93,9.883,9.883,0,0,1,15.469,6.645,10.5,10.5,0,0,1-2.377,20.727H105.645a10.094,10.094,0,0,1-3.811-19.441Z",
    transform: "translate(-95.549 -157.028)",
    fill: "#66c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114367",
    "data-name": "Path 114367",
    d: "M152.336,206.861a8.934,8.934,0,0,0,.187-1.823,8.839,8.839,0,0,0-.189-1.826l-1.427-.2a7.457,7.457,0,0,0-.7-1.679l.864-1.156a8.888,8.888,0,0,0-2.583-2.583l-1.154.866a7.33,7.33,0,0,0-1.679-.7l-.2-1.426a8.935,8.935,0,0,0-3.654,0l-.2,1.426a7.411,7.411,0,0,0-1.682.7l-1.154-.864a8.924,8.924,0,0,0-2.579,2.579l.864,1.157a7.441,7.441,0,0,0-.7,1.679l-1.428.2a8.837,8.837,0,0,0-.188,1.826,8.933,8.933,0,0,0,.187,1.823l1.429.205a7.293,7.293,0,0,0,.7,1.676l-.869,1.161a8.929,8.929,0,0,0,2.579,2.579l1.157-.867a7.321,7.321,0,0,0,1.679.7l.2,1.432a8.919,8.919,0,0,0,3.651,0l.2-1.432a7.318,7.318,0,0,0,1.679-.7l1.156.869a8.948,8.948,0,0,0,2.581-2.581l-.869-1.157a7.4,7.4,0,0,0,.7-1.679Zm-8.707,2.463a4.288,4.288,0,1,1,4.288-4.288A4.284,4.284,0,0,1,143.629,209.324Z",
    transform: "translate(-120.316 -169.115)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114368",
    "data-name": "Path 114368",
    d: "M258.277,159.738a10.566,10.566,0,0,1,16-7.93,9.883,9.883,0,0,1,15.469,6.644,10.5,10.5,0,0,1-2.377,20.727H262.088a10.094,10.094,0,0,1-3.811-19.441Z",
    transform: "translate(-194.419 -139.956)",
    fill: "#66c5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115639",
    "data-name": "Group 115639",
    transform: "translate(29.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115638",
    "data-name": "Group 115638",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22369",
    "data-name": "Rectangle 22369",
    d: "M8.808,0H47.693A8.808,8.808,0,0,1,56.5,8.808V26.571A10.5,10.5,0,0,1,46,37.068H10.5A10.5,10.5,0,0,1,0,26.571V8.808A8.808,8.808,0,0,1,8.808,0Z",
    transform: "translate(0)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22370",
    "data-name": "Rectangle 22370",
    d: "M0,0H56.5a0,0,0,0,1,0,0V28.26a8.808,8.808,0,0,1-8.808,8.808H8.808A8.808,8.808,0,0,1,0,28.26V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 6.103)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22371",
    "data-name": "Rectangle 22371",
    d: "M0,0H30.88a4.662,4.662,0,0,1,4.662,4.662V48.787a4.662,4.662,0,0,1-4.662,4.662H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(54.975 6.103) rotate(90)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115635",
    "data-name": "Group 115635",
    transform: "translate(18.216 19.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114435",
    "data-name": "Path 114435",
    d: "M244.716,186.9v-3.324l-2.283-.326a7.109,7.109,0,0,0-.865-2.094l1.379-1.831-2.345-2.358-1.845,1.38a7.159,7.159,0,0,0-2.095-.865l-.326-2.271h-3.325l-.326,2.271a7.159,7.159,0,0,0-2.095.865l-1.83-1.38-2.359,2.358,1.379,1.831a6.851,6.851,0,0,0-.865,2.094l-2.271.326V186.9l2.271.326a7.052,7.052,0,0,0,.865,2.107l-1.379,1.831,2.359,2.346,1.83-1.38a6.872,6.872,0,0,0,2.095.878l.326,2.271h3.325l.326-2.271a6.872,6.872,0,0,0,2.095-.878l1.845,1.38,2.345-2.346-1.379-1.844a7.4,7.4,0,0,0,.865-2.095Zm-10.034,3.361a5.023,5.023,0,1,1,5.017-5.017A5.009,5.009,0,0,1,234.682,190.261Z",
    transform: "translate(-224.647 -175.209)",
    fill: "#425160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114436",
    "data-name": "Path 114436",
    d: "M234.666,190.26a5.023,5.023,0,0,1,0-10.045v-5.006h-1.653l-.326,2.271a7.17,7.17,0,0,0-2.095.865l-1.83-1.38-2.359,2.358,1.379,1.831a6.851,6.851,0,0,0-.865,2.094l-2.271.326V186.9l2.271.326a7.052,7.052,0,0,0,.865,2.107l-1.379,1.831,2.359,2.346,1.83-1.38a6.872,6.872,0,0,0,2.095.878l.326,2.271h1.653Z",
    transform: "translate(-224.647 -175.209)",
    fill: "#3d4959"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_114437",
    "data-name": "Path 114437",
    d: "M288.139,156.26v-2.369l-1.628-.233a5.064,5.064,0,0,0-.616-1.493l.983-1.305-1.672-1.681-1.315.984a5.111,5.111,0,0,0-1.493-.617l-.232-1.619H279.8l-.232,1.619a5.111,5.111,0,0,0-1.493.617l-1.3-.984-1.681,1.681.983,1.305a4.894,4.894,0,0,0-.616,1.493l-1.619.233v2.369l1.619.233a5.038,5.038,0,0,0,.616,1.5l-.983,1.305,1.681,1.672,1.3-.983a4.883,4.883,0,0,0,1.493.626l.232,1.619h2.37l.232-1.619a4.883,4.883,0,0,0,1.493-.626l1.315.983,1.672-1.672-.983-1.314a5.267,5.267,0,0,0,.616-1.493Zm-7.153,2.4a3.581,3.581,0,1,1,3.576-3.576A3.57,3.57,0,0,1,280.987,158.656Z",
    transform: "translate(-237.517 -138.642)",
    fill: "#41566d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22372",
    "data-name": "Rectangle 22372",
    width: 17.842,
    height: 1.483,
    transform: "translate(3.443 7.967)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22373",
    "data-name": "Rectangle 22373",
    width: 17.842,
    height: 1.483,
    transform: "translate(3.443 11.471)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22374",
    "data-name": "Rectangle 22374",
    width: 17.842,
    height: 1.483,
    transform: "translate(3.443 14.975)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22375",
    "data-name": "Rectangle 22375",
    width: 13.985,
    height: 1.483,
    transform: "translate(3.443 18.479)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22376",
    "data-name": "Rectangle 22376",
    width: 13.985,
    height: 1.483,
    transform: "translate(3.443 21.983)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115636",
    "data-name": "Group 115636",
    transform: "translate(40.638 1.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114438",
    "data-name": "Path 114438",
    d: "M288.062,129.006a1.244,1.244,0,1,1-1.244-1.244A1.244,1.244,0,0,1,288.062,129.006Z",
    transform: "translate(-285.574 -127.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114439",
    "data-name": "Path 114439",
    d: "M301.879,129.006a1.244,1.244,0,1,1-1.244-1.244A1.244,1.244,0,0,1,301.879,129.006Z",
    transform: "translate(-294.306 -127.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114440",
    "data-name": "Path 114440",
    d: "M315.7,129.006a1.244,1.244,0,1,1-1.244-1.244A1.244,1.244,0,0,1,315.7,129.006Z",
    transform: "translate(-303.038 -127.762)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115637",
    "data-name": "Group 115637",
    transform: "translate(3.294 36.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114441",
    "data-name": "Path 114441",
    d: "M281.287,223.787a.994.994,0,1,1-.994-.994A.994.994,0,0,1,281.287,223.787Z",
    transform: "translate(-244.264 -222.383)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114442",
    "data-name": "Path 114442",
    d: "M292.961,223.787a.995.995,0,1,1-.994-.994A.995.995,0,0,1,292.961,223.787Z",
    transform: "translate(-251.642 -222.383)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114443",
    "data-name": "Path 114443",
    d: "M304.343,223.084a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,304.343,223.084Z",
    transform: "translate(-258.318 -221.68)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114444",
    "data-name": "Path 114444",
    d: "M316.31,223.787a.995.995,0,1,1-.994-.994A.995.995,0,0,1,316.31,223.787Z",
    transform: "translate(-266.398 -222.383)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114445",
    "data-name": "Path 114445",
    d: "M186.09,223.787a.995.995,0,1,1-.994-.994A.995.995,0,0,1,186.09,223.787Z",
    transform: "translate(-184.101 -222.383)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114446",
    "data-name": "Path 114446",
    d: "M197.765,223.787a.994.994,0,1,1-.994-.994A.995.995,0,0,1,197.765,223.787Z",
    transform: "translate(-191.479 -222.383)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114447",
    "data-name": "Path 114447",
    d: "M209.439,223.787a.995.995,0,1,1-.994-.994A.994.994,0,0,1,209.439,223.787Z",
    transform: "translate(-198.857 -222.383)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114448",
    "data-name": "Path 114448",
    d: "M221.114,223.787a.994.994,0,1,1-.994-.994A.994.994,0,0,1,221.114,223.787Z",
    transform: "translate(-206.236 -222.383)",
    fill: "#24a7ff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114449",
    "data-name": "Path 114449",
    d: "M137.153,132.4v-2.727l-1.873-.268a5.828,5.828,0,0,0-.709-1.718l1.131-1.5-1.923-1.934-1.513,1.132a5.878,5.878,0,0,0-1.718-.71l-.268-1.863h-2.727l-.267,1.863a5.88,5.88,0,0,0-1.718.71l-1.5-1.132-1.935,1.934,1.131,1.5a5.621,5.621,0,0,0-.71,1.718l-1.863.268V132.4l1.863.268a5.788,5.788,0,0,0,.71,1.729l-1.131,1.5,1.935,1.924,1.5-1.132a5.634,5.634,0,0,0,1.718.72l.267,1.862h2.727l.268-1.862a5.632,5.632,0,0,0,1.718-.72l1.513,1.132L135.7,135.9l-1.131-1.513a6.066,6.066,0,0,0,.709-1.718Zm-8.231,2.052a3.415,3.415,0,1,1,3.411-3.411A3.406,3.406,0,0,1,128.921,134.452Z",
    transform: "translate(-111.438 -122.769)",
    fill: "#66c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114450",
    "data-name": "Path 114450",
    d: "M371.581,236.975v-2.362l-1.622-.231a5.045,5.045,0,0,0-.615-1.488l.98-1.3-1.666-1.676-1.31.98a5.091,5.091,0,0,0-1.488-.615l-.231-1.613h-2.362l-.231,1.613a5.1,5.1,0,0,0-1.488.615l-1.3-.98-1.676,1.676.98,1.3a4.868,4.868,0,0,0-.614,1.488l-1.613.231v2.362l1.613.231a5.017,5.017,0,0,0,.614,1.5l-.98,1.3,1.676,1.666,1.3-.98a4.878,4.878,0,0,0,1.488.624l.231,1.613h2.362l.231-1.613a4.872,4.872,0,0,0,1.488-.624l1.31.98L370.324,240l-.98-1.31a5.254,5.254,0,0,0,.615-1.488Zm-7.128,1.777a2.958,2.958,0,1,1,2.954-2.954A2.949,2.949,0,0,1,364.452,238.752Z",
    transform: "translate(-260.987 -189.671)",
    fill: "#66c5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115643",
    "data-name": "Group 115643",
    transform: "translate(87.901 6.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114477",
    "data-name": "Path 114477",
    d: "M336.389,142.639a.994.994,0,1,1-.994-.994A.994.994,0,0,1,336.389,142.639Z",
    transform: "translate(-334.4 -141.236)",
    fill: "#dde9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114478",
    "data-name": "Path 114478",
    d: "M348.064,142.639a.994.994,0,1,1-.994-.994A.994.994,0,0,1,348.064,142.639Z",
    transform: "translate(-341.778 -141.236)",
    fill: "#dde9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114479",
    "data-name": "Path 114479",
    d: "M359.445,141.937a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,359.445,141.937Z",
    transform: "translate(-348.453 -140.533)",
    fill: "#dde9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114480",
    "data-name": "Path 114480",
    d: "M371.413,142.639a.994.994,0,1,1-.994-.994A.994.994,0,0,1,371.413,142.639Z",
    transform: "translate(-356.535 -141.236)",
    fill: "#dde9f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115654",
    "data-name": "Group 115654",
    transform: "translate(33.05 44.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115647",
    "data-name": "Group 115647",
    transform: "translate(47.3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115646",
    "data-name": "Group 115646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115645",
    "data-name": "Group 115645"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22377",
    "data-name": "Rectangle 22377",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22378",
    "data-name": "Rectangle 22378",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22379",
    "data-name": "Rectangle 22379",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22380",
    "data-name": "Rectangle 22380",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22381",
    "data-name": "Rectangle 22381",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22382",
    "data-name": "Rectangle 22382",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22383",
    "data-name": "Rectangle 22383",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22384",
    "data-name": "Rectangle 22384",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22385",
    "data-name": "Rectangle 22385",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22386",
    "data-name": "Rectangle 22386",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116570",
    "data-name": "Group 116570",
    transform: "translate(23.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115650",
    "data-name": "Group 115650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115649",
    "data-name": "Group 115649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115648",
    "data-name": "Group 115648"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22387",
    "data-name": "Rectangle 22387",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22388",
    "data-name": "Rectangle 22388",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22389",
    "data-name": "Rectangle 22389",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22390",
    "data-name": "Rectangle 22390",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22391",
    "data-name": "Rectangle 22391",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22392",
    "data-name": "Rectangle 22392",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22393",
    "data-name": "Rectangle 22393",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22394",
    "data-name": "Rectangle 22394",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22395",
    "data-name": "Rectangle 22395",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22396",
    "data-name": "Rectangle 22396",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116569",
    "data-name": "Group 116569",
    transform: "translate(0 37.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115649-2",
    "data-name": "Group 115649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115648-2",
    "data-name": "Group 115648"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22387-2",
    "data-name": "Rectangle 22387",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22388-2",
    "data-name": "Rectangle 22388",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22389-2",
    "data-name": "Rectangle 22389",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22390-2",
    "data-name": "Rectangle 22390",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22391-2",
    "data-name": "Rectangle 22391",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22392-2",
    "data-name": "Rectangle 22392",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22393-2",
    "data-name": "Rectangle 22393",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22394-2",
    "data-name": "Rectangle 22394",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22395-2",
    "data-name": "Rectangle 22395",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22396-2",
    "data-name": "Rectangle 22396",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116567",
    "data-name": "Group 116567",
    transform: "translate(0 18.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115649-3",
    "data-name": "Group 115649",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115648-3",
    "data-name": "Group 115648"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22387-3",
    "data-name": "Rectangle 22387",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22388-3",
    "data-name": "Rectangle 22388",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22389-3",
    "data-name": "Rectangle 22389",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22390-3",
    "data-name": "Rectangle 22390",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22391-3",
    "data-name": "Rectangle 22391",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22392-3",
    "data-name": "Rectangle 22392",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22393-3",
    "data-name": "Rectangle 22393",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22394-3",
    "data-name": "Rectangle 22394",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22395-3",
    "data-name": "Rectangle 22395",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22396-3",
    "data-name": "Rectangle 22396",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116568",
    "data-name": "Group 116568",
    transform: "translate(0 55.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115649-4",
    "data-name": "Group 115649",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115648-4",
    "data-name": "Group 115648"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22387-4",
    "data-name": "Rectangle 22387",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22388-4",
    "data-name": "Rectangle 22388",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22389-4",
    "data-name": "Rectangle 22389",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22390-4",
    "data-name": "Rectangle 22390",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22391-4",
    "data-name": "Rectangle 22391",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22392-4",
    "data-name": "Rectangle 22392",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22393-4",
    "data-name": "Rectangle 22393",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22394-4",
    "data-name": "Rectangle 22394",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22395-4",
    "data-name": "Rectangle 22395",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22396-4",
    "data-name": "Rectangle 22396",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115653",
    "data-name": "Group 115653",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115652",
    "data-name": "Group 115652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115651",
    "data-name": "Group 115651"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22397",
    "data-name": "Rectangle 22397",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22398",
    "data-name": "Rectangle 22398",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22399",
    "data-name": "Rectangle 22399",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22400",
    "data-name": "Rectangle 22400",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22401",
    "data-name": "Rectangle 22401",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22402",
    "data-name": "Rectangle 22402",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22403",
    "data-name": "Rectangle 22403",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22404",
    "data-name": "Rectangle 22404",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22405",
    "data-name": "Rectangle 22405",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22406",
    "data-name": "Rectangle 22406",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116579",
    "data-name": "Group 116579",
    transform: "translate(17.857 16.167) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115652-2",
    "data-name": "Group 115652",
    transform: "translate(2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115651-2",
    "data-name": "Group 115651"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22397-2",
    "data-name": "Rectangle 22397",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22398-2",
    "data-name": "Rectangle 22398",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22399-2",
    "data-name": "Rectangle 22399",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22400-2",
    "data-name": "Rectangle 22400",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22401-2",
    "data-name": "Rectangle 22401",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22402-2",
    "data-name": "Rectangle 22402",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22403-2",
    "data-name": "Rectangle 22403",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22404-2",
    "data-name": "Rectangle 22404",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22405-2",
    "data-name": "Rectangle 22405",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22406-2",
    "data-name": "Rectangle 22406",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22461",
    "data-name": "Rectangle 22461",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 -1.873)",
    fill: "#55738e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116580",
    "data-name": "Group 116580",
    transform: "translate(43.116 16.167) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115652-3",
    "data-name": "Group 115652",
    transform: "translate(2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115651-3",
    "data-name": "Group 115651"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22397-3",
    "data-name": "Rectangle 22397",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 16.86)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22398-3",
    "data-name": "Rectangle 22398",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 14.986)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22399-3",
    "data-name": "Rectangle 22399",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 13.113)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22400-3",
    "data-name": "Rectangle 22400",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 11.24)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22401-3",
    "data-name": "Rectangle 22401",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 9.366)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22402-3",
    "data-name": "Rectangle 22402",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 7.493)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22403-3",
    "data-name": "Rectangle 22403",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 5.62)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22404-3",
    "data-name": "Rectangle 22404",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 3.747)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22405-3",
    "data-name": "Rectangle 22405",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 1.873)",
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22406-3",
    "data-name": "Rectangle 22406",
    width: 1.689,
    height: 0.997,
    fill: "#55738e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22461-2",
    "data-name": "Rectangle 22461",
    width: 1.689,
    height: 0.997,
    transform: "translate(0 -1.873)",
    fill: "#55738e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116564",
    "data-name": "Group 116564",
    transform: "translate(170.064 168.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115626",
    "data-name": "Group 115626",
    transform: "translate(30.826 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115625",
    "data-name": "Group 115625",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115619",
    "data-name": "Group 115619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114395",
    "data-name": "Path 114395",
    d: "M256.97,317.124a13.22,13.22,0,0,0-9.241-12.606,12.455,12.455,0,0,0-19.261-8.8,12.456,12.456,0,0,0-19.262,8.8,13.217,13.217,0,0,0,3.975,25.822h30.866l-.005-.008A13.213,13.213,0,0,0,256.97,317.124Z",
    transform: "translate(-199.965 -293.632)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114396",
    "data-name": "Path 114396",
    d: "M228.357,295.651a12.454,12.454,0,0,0-19.152,8.867,13.217,13.217,0,0,0,3.975,25.822h9.286Z",
    transform: "translate(-199.965 -293.632)",
    fill: "#3bb0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115624",
    "data-name": "Group 115624",
    transform: "translate(2.947 22.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115620",
    "data-name": "Group 115620",
    transform: "translate(4.296 13.254)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22353",
    "data-name": "Rectangle 22353",
    width: 42.701,
    height: 3.178,
    transform: "translate(0 15.398)",
    fill: "#3d4959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22354",
    "data-name": "Rectangle 22354",
    width: 42.701,
    height: 3.178,
    fill: "#3d4959"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22355",
    "data-name": "Rectangle 22355",
    d: "M4.006,0H47.1a4.006,4.006,0,0,1,4.006,4.006v6.273A4.005,4.005,0,0,1,47.1,14.284H4.006A4.006,4.006,0,0,1,0,10.279V4.006A4.006,4.006,0,0,1,4.006,0Z",
    transform: "translate(0.001 31.043)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114397",
    "data-name": "Path 114397",
    d: "M226.546,391.533l-2.327,14.282H207.536a2.2,2.2,0,0,1-2.2-2.2v-9.891a2.2,2.2,0,0,1,2.2-2.2Z",
    transform: "translate(-205.337 -360.488)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22356",
    "data-name": "Rectangle 22356",
    width: 7.994,
    height: 44.819,
    transform: "translate(47.965 34.189) rotate(90)",
    fill: "#3d4959"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115621",
    "data-name": "Group 115621",
    transform: "translate(18.871 36.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114398",
    "data-name": "Path 114398",
    d: "M284.045,403.416a1.376,1.376,0,1,1-1.376-1.376A1.375,1.375,0,0,1,284.045,403.416Z",
    transform: "translate(-258.49 -402.041)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114399",
    "data-name": "Path 114399",
    d: "M273.53,403.578a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,273.53,403.578Z",
    transform: "translate(-253.922 -402.202)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114400",
    "data-name": "Path 114400",
    d: "M263.051,403.578a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,263.051,403.578Z",
    transform: "translate(-249.192 -402.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114401",
    "data-name": "Path 114401",
    d: "M252.571,403.578a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,252.571,403.578Z",
    transform: "translate(-244.462 -402.202)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114402",
    "data-name": "Path 114402",
    d: "M242.091,403.578a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,242.091,403.578Z",
    transform: "translate(-239.732 -402.202)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22357",
    "data-name": "Rectangle 22357",
    width: 51.109,
    height: 14.284,
    rx: 4.006,
    transform: "translate(0.001 15.399)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114403",
    "data-name": "Path 114403",
    d: "M229.093,363.02,226.769,377.3H207.536a2.2,2.2,0,0,1-2.2-2.2v-9.891a2.2,2.2,0,0,1,2.2-2.2Z",
    transform: "translate(-205.337 -347.62)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22358",
    "data-name": "Rectangle 22358",
    width: 7.994,
    height: 44.819,
    transform: "translate(47.965 18.545) rotate(90)",
    fill: "#3d4959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22359",
    "data-name": "Rectangle 22359",
    d: "M4.006,0H47.1a4.006,4.006,0,0,1,4.006,4.006v6.273A4.005,4.005,0,0,1,47.1,14.284H4.006A4.006,4.006,0,0,1,0,10.279V4.006A4.006,4.006,0,0,1,4.006,0Z",
    transform: "translate(0.001 0.001)",
    fill: "#d6e0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114404",
    "data-name": "Path 114404",
    d: "M231.6,334.951l-2.327,14.286H207.536a2.2,2.2,0,0,1-2.2-2.2V337.15a2.2,2.2,0,0,1,2.2-2.2Z",
    transform: "translate(-205.337 -334.951)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22360",
    "data-name": "Rectangle 22360",
    width: 7.994,
    height: 44.819,
    transform: "translate(47.965 3.146) rotate(90)",
    fill: "#3d4959"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115622",
    "data-name": "Group 115622",
    transform: "translate(18.871 21.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114405",
    "data-name": "Path 114405",
    d: "M284.045,374.9a1.376,1.376,0,1,1-1.376-1.376A1.375,1.375,0,0,1,284.045,374.9Z",
    transform: "translate(-258.49 -373.528)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114406",
    "data-name": "Path 114406",
    d: "M273.53,375.065a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,273.53,375.065Z",
    transform: "translate(-253.922 -373.689)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114407",
    "data-name": "Path 114407",
    d: "M263.051,375.065a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,263.051,375.065Z",
    transform: "translate(-249.192 -373.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114408",
    "data-name": "Path 114408",
    d: "M252.571,375.065a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,252.571,375.065Z",
    transform: "translate(-244.462 -373.689)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114409",
    "data-name": "Path 114409",
    d: "M242.091,375.065a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,242.091,375.065Z",
    transform: "translate(-239.732 -373.689)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115623",
    "data-name": "Group 115623",
    transform: "translate(18.871 5.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114410",
    "data-name": "Path 114410",
    d: "M284.045,346.839a1.376,1.376,0,1,1-1.376-1.376A1.376,1.376,0,0,1,284.045,346.839Z",
    transform: "translate(-258.49 -345.463)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114411",
    "data-name": "Path 114411",
    d: "M273.53,347a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,273.53,347Z",
    transform: "translate(-253.922 -345.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114412",
    "data-name": "Path 114412",
    d: "M263.051,347a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,263.051,347Z",
    transform: "translate(-249.192 -345.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114413",
    "data-name": "Path 114413",
    d: "M252.571,347a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,252.571,347Z",
    transform: "translate(-244.462 -345.624)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114414",
    "data-name": "Path 114414",
    d: "M242.091,347a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,242.091,347Z",
    transform: "translate(-239.732 -345.624)",
    fill: "#24a7ff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114451",
    "data-name": "Path 114451",
    d: "M328.725,391.514v-2.33l-1.6-.228a4.99,4.99,0,0,0-.606-1.468l.967-1.283-1.643-1.653-1.293.967a5.019,5.019,0,0,0-1.468-.606l-.228-1.591h-2.33l-.228,1.591a5.023,5.023,0,0,0-1.468.606l-1.283-.967-1.653,1.653.967,1.283a4.791,4.791,0,0,0-.606,1.468l-1.592.228v2.33l1.592.229a4.93,4.93,0,0,0,.606,1.476l-.967,1.283,1.653,1.644,1.283-.967a4.827,4.827,0,0,0,1.468.616l.228,1.591h2.33l.228-1.591a4.824,4.824,0,0,0,1.468-.616l1.293.967,1.643-1.644-.967-1.292a5.189,5.189,0,0,0,.606-1.468Zm-7.032,1.753a2.918,2.918,0,1,1,2.914-2.914A2.909,2.909,0,0,1,321.693,393.267Z",
    transform: "translate(-220.905 -334.112)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116565",
    "data-name": "Group 116565",
    transform: "translate(39.072 71.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114452",
    "data-name": "Path 114452",
    d: "M214.994,426.016c0-1.609.861-2.527,2.018-2.527s2.011.917,2.011,2.527-.861,2.526-2.011,2.526S214.994,427.624,214.994,426.016Zm3.324,0c0-1.264-.537-1.9-1.306-1.9s-1.312.635-1.312,1.9.537,1.9,1.312,1.9S218.318,427.279,218.318,426.016Z",
    transform: "translate(-214.994 -423.489)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114453",
    "data-name": "Path 114453",
    d: "M223.577,426.016c0-1.609.861-2.527,2.019-2.527s2.011.917,2.011,2.527-.861,2.526-2.011,2.526S223.577,427.624,223.577,426.016Zm3.324,0c0-1.264-.537-1.9-1.305-1.9s-1.313.635-1.313,1.9.537,1.9,1.313,1.9S226.9,427.279,226.9,426.016Z",
    transform: "translate(-218.868 -423.489)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114454",
    "data-name": "Path 114454",
    d: "M233.42,423.592v4.94h-.7v-4.325h-1.115v-.614Z",
    transform: "translate(-222.492 -423.536)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114455",
    "data-name": "Path 114455",
    d: "M236.883,426.016c0-1.609.861-2.527,2.019-2.527s2.011.917,2.011,2.527-.861,2.526-2.011,2.526S236.883,427.624,236.883,426.016Zm3.324,0c0-1.264-.537-1.9-1.305-1.9s-1.313.635-1.313,1.9.537,1.9,1.313,1.9S240.207,427.279,240.207,426.016Z",
    transform: "translate(-224.873 -423.489)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114456",
    "data-name": "Path 114456",
    d: "M246.726,423.592v4.94h-.7v-4.325h-1.115v-.614Z",
    transform: "translate(-228.498 -423.536)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114457",
    "data-name": "Path 114457",
    d: "M250.189,426.016c0-1.609.861-2.527,2.018-2.527s2.011.917,2.011,2.527-.861,2.526-2.011,2.526S250.189,427.624,250.189,426.016Zm3.324,0c0-1.264-.537-1.9-1.306-1.9s-1.312.635-1.312,1.9.536,1.9,1.312,1.9S253.513,427.279,253.513,426.016Z",
    transform: "translate(-230.879 -423.489)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114458",
    "data-name": "Path 114458",
    d: "M260.033,423.592v4.94h-.7v-4.325h-1.115v-.614Z",
    transform: "translate(-234.503 -423.536)",
    fill: "#24a7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116566",
    "data-name": "Group 116566",
    transform: "translate(0 49.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114481",
    "data-name": "Path 114481",
    d: "M178.8,385.952a1.483,1.483,0,1,1,1.483,1.483A1.483,1.483,0,0,1,178.8,385.952Z",
    transform: "translate(-159.588 -383.859)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114482",
    "data-name": "Path 114482",
    d: "M167.13,385.952a1.482,1.482,0,1,1,1.482,1.483A1.483,1.483,0,0,1,167.13,385.952Z",
    transform: "translate(-154.319 -383.859)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114483",
    "data-name": "Path 114483",
    d: "M154.343,385.45a2.093,2.093,0,1,1,2.093,2.093A2.093,2.093,0,0,1,154.343,385.45Z",
    transform: "translate(-148.548 -383.357)",
    fill: "#24a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114484",
    "data-name": "Path 114484",
    d: "M143.781,385.952a1.482,1.482,0,1,1,1.482,1.483A1.483,1.483,0,0,1,143.781,385.952Z",
    transform: "translate(-143.781 -383.859)",
    fill: "#24a7ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116571",
    "data-name": "Group 116571",
    transform: "translate(217.387 104.16) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22414-2",
    "data-name": "Rectangle 22414",
    width: 6.582,
    height: 21.939,
    transform: "translate(21.939 7.806) rotate(90)",
    fill: "#ff6363"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22415-2",
    "data-name": "Rectangle 22415",
    width: 6.582,
    height: 21.939,
    transform: "translate(14.387 21.939) rotate(180)",
    fill: "#ff6363"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22460",
    "data-name": "Rectangle 22460",
    width: 398.696,
    height: 1.201,
    transform: "translate(-5653.229 14705.92)",
    fill: "#91b3fa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVmFound);
export default __webpack_public_path__ + "static/media/noVmFound.5e9ad3758dc53fcc820038a4e4e496bf.svg";
export { ForwardRef as ReactComponent };